<template>
    <div>
        <v-card elevation="0">
            <v-card-text>
                <v-simple-table style="width: 100%; border: none;" dense v-if="selectedCourses.length > 0">
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th>Discipline</th>
                                <th>Subject</th>
                                <th>Section</th>
                                <th>Class #</th>
                                <th>Catalog</th>
                                <th>Instructor</th>
                                <th>Component</th>
                                <th>Session</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="course in selectedCourses" :key="course.classnbr">
                                <td>{{ course.subject }}</td>
                                <td>{{ course["subject-resolved"] }}</td>
                                <td>{{ course.classsection }}</td>
                                <td>{{ course.classnbr }}</td>
                                <td>{{ course.catalognbr }}</td>
                                <td><v-chip color="#D3B5E5" v-if="course.instructorname.length>0">{{ course.instructorname }}</v-chip></td>
                                <td><v-chip color="#98D7C2" v-if="course.ssrcomponent == 'LEC'">{{ course.ssrcomponent }}</v-chip><span v-else>{{ course.ssrcomponent }}</span></td>
                                <td>{{ course.sessioncode }}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
                <br />
                <v-row>
                    <v-col cols="12" md="6">
                        <v-text-field
                            v-model="postingTitle"
                            label="Discipline"
                            prepend-icon="mdi-file-document-outline"
                            @keydown="validatebtn"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-textarea
                            outlined
                            label="Qualifications"
                            v-model="qualification"
                            height="250px"
                            @keydown="validatebtn"
                        ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-textarea
                            outlined
                            label="Additional Notes"
                            v-model="notes"
                            height="250px"
                            @keydown="validatebtn"
                        ></v-textarea>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-menu
                            v-model="menustart"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="postingstartdate"
                                    label="Posting Start Date"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="postingstartdate"
                                :show-current="today"
                                @input="validateStart"
                                color="#189AB4"
                                no-title
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-menu
                            v-model="menuend"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="postingenddate"
                                    label="Posting End Date"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="postingenddate"
                                :show-current="postingstartdate"
                                @input="validateEnd"
                                no-title
                                color="#189AB4"
                                :allowed-dates="validateEndDate"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field
                            v-model="salary" prefix="$"
                            label="Salary"
                            prepend-icon="mdi-cash-multiple"
                            @keydown="validatebtn"
                            v-if="cluster"
                        ></v-text-field>
                        <v-simple-table style="width: 100%; border-collapse: collapse;" v-else>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th>Effective Date as of May 1</th>
                                        <th>0.5 Course Load</th>
                                        <th>1.0 Course Load</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in courseSalary" :key="item">
                                        <td>{{ item.year }}</td>
                                        <td>${{ item.halfcourse }}</td>
                                        <td>${{ item.fullcourse }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-textarea
                            outlined
                            label="Comment for Live Edit (shown for admins only)"
                            v-model="liveeditreason"
                            height="120px"
                            @keydown="validatebtn"
                        ></v-textarea>
                    </v-col>
                </v-row>
                <v-row justify="end" align="end">
                    <v-col cols="3" style="text-align: right;">
                        <v-btn color="#60A3D9" @click="editPosting" :loading="submitloading" :disabled="disablesubmitbtn">
                            Update Posting
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
export default {
    props: {
        item : {
            required: true
        }
    },
    data(){
        return {
            host: location.hostname.toString(),
            today: "",
            sessioncoderesolution: [],
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 3500,
            selectedCourses: [],
            selecteddeleteCourse: {},
            postingTitle: "",
            qualification: "",
            notes: "",
            menustart: false,
            menuend: false,
            postingstartdate: "",
            postingenddate: "",
            menuinstructionstart: false,
            menuinstructionend: false,
            salary: "",
            courseSalary: [],
            disablesubmitbtn: false,
            submitloading: false,
            addbtnLoading: false,
            cluster: false,
            department: "",
            liveeditreason: ""
        }
    },
    methods: {
        initializeValue(){
            const that = this;

            that.selectedCourses = that.item.courses;
            that.postingTitle = that.item.title;
            that.qualification = that.item.qualifications;
            that.notes = that.item.notes;
            that.postingstartdate = that.item.startDate;
            that.postingenddate = that.item.endDate;
            if(that.item.type == "CLUSTER") {
                that.cluster = true;
                that.salary = that.item.salary;
            }else {
                that.cluster = false;
                that.courseSalary = that.item.salary;
            }

            that.department = that.item.department;
        },
        getSalaryInfo(){
            const that = this;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=getFormControl&data={"type": "salary"}';

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    if (json.result.match(/^OK/i)) {
                        if(json.data.length > 0){
                            if(that.courseSalary.length == 0){
                                that.courseSalary = json.data[0]["config"]["grid"];
                            }
                        }
                    }
                })
                .catch(function () {
                })
        },
        getSessionCodeResolution(){
            const that = this;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=getFormControl&data={"type":"instructiondates"}';

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    if (json.result.match(/^OK/i)) {
                        if(json.data.length > 0){
                            that.sessioncoderesolution = json.data[0].config.dates;
                        }
                    }else {
                        that.setSnackbar("Warning: "+json.message, "#EF6C00"); //orange
                    }
                })
                .catch(function (err) {
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
        },
        getDate(){
            const that = this;
            let date = new Date().toISOString().slice(0, 10);

            that.today = date;
        },
        translateTimestamp(timestamp){
            const that = this;

            var date = new Date(parseInt(timestamp));

            that.uploadeddate = date.toDateString();
        },
        splitMeetingTime(meetingtime){
            return meetingtime.split(" ")[1]
        },
        resolveGeneralTerm(strm){
            const that = this;
            let term = strm.slice(-1);
            if(term == "9"){
                var year = strm[1]+strm[2];
                var year2 = (parseInt(year)+1).toString();
                var century = (parseInt(strm[0])-1).toString();
                return "FALL2"+century+year+"/WINTER2"+century+year2;
            }else if(term == "5"){
                return "SUMMER";
            }
        },
        validateStart(){
            const that = this;

            that.menustart = false;
            that.validatebtn();
        },
        validateEnd(){
            const that = this;

            that.menuend = false;
            that.validatebtn();
        },
        validateEndDate(val){
            const that = this;

            return val >= that.postingstartdate
        },
        validatebtn(){
            const that = this;
            if(that.selectedCourses.length > 0 && that.qualification.length>0 && that.postingstartdate.length>0 && that.postingenddate.length>0){
                that.disablesubmitbtn = false;
            }else {
                that.disablesubmitbtn = true;
            }
        },
        resolveSessionCode(){
            const that = this;

            that.selectedCourses.forEach(element => {
                that.sessioncoderesolution.forEach(codes => {
                    if(element["sessioncode"] == codes["code"]){
                        element["instructionstart"] = codes["startdate"];
                        element["instructionend"] = codes["enddate"];
                    }
                });
            });
        },
        resolvePostingType(){
            const that = this;
            var leccount = 0;
            that.selectedCourses.forEach(element => {
                if(element["ssrcomponent"] == "LEC"){
                    leccount = leccount + 1;
                }
            });

            if(leccount > 1){
                that.cluster = true;
            }else {
                that.cluster = false;
            }
        },
        editPosting(){
            const that = this;
            let api= 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';
            that.submitloading = true;

            that.resolveSessionCode();
            var savesalary = "";
            //Cluster Posting resolution
            let postingtype = "";
            var leccount = 0;
            that.selectedCourses.forEach(element => {
                if(element["ssrcomponent"] == "LEC"){
                    leccount = leccount + 1;
                }
            });

            if(leccount > 1){
                postingtype = "CLUSTER";
                savesalary = that.salary;
            }else {
                postingtype = "COURSE";
                savesalary = that.courseSalary;
            }
            //End of cluster posting resolution

            var postinginfo = {
                id: that.item.id,
                title: that.postingTitle,
                discipline: that.selectedCourses[0]["subject"],
                strm: that.selectedCourses[0]["strm"],
                courses: that.selectedCourses,
                startDate: that.postingstartdate,
                endDate: that.postingenddate,
                qualifications: that.qualification,
                notes: that.notes,
                type: postingtype,
                salary: savesalary,
                liveedit: that.liveeditreason
            };

            const formData = new FormData();
            formData.append("mode", "postingliveedit");
            formData.append("data", JSON.stringify(postinginfo));

            fetch(api, {
                method: 'POST',
                body: formData
            })
            .then(function(response){
                return response.json();
            })
            .then(function (data) {
                if(data.result.match(/ok/i)){
                    that.setSnackbar("Posting successfully updated", "green");
                    that.submitloading = false;
                    that.disablesubmitbtn = true;
                    
                    
                }else {
                    that.setSnackbar("Warning: "+data.message.toString(), "orange");
                    that.submitloading = false;
                    that.disablesubmitbtn = true;
                }
            })
            .catch(function (err) {
                that.setSnackbar("Error occurred : "+err.toString(), "red")
                that.submitloading = false;
                that.disablesubmitbtn = true;
            })
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        }
    },
    created(){
        const that = this; 
        that.getDate();
        that.initializeValue();
        that.getSessionCodeResolution();
        that.getSalaryInfo();
    }
}
</script>